import '@cash-design-system/react' // Just for the darkMode type on Theme object.

import { EmojiNameNew, EmojisNew } from './emojisNew'
import { EmojiNameOld, EmojisOld } from './emojisOld'

const unicodeToOldEmojiNameMap: { [key: string]: EmojiNameOld } = {
  '💰': 'MONEYBAG',
  '🏝': 'DESERT_ISLAND',
  '🎁': 'GIFT',
  '🎓': 'SCHOOL',
  '🏡': 'HOME',
  '☔️': 'RAINY_DAY',
  '🎂': 'CAKE',
  '🤒': 'SICK',
  '🎮': 'GAME',
  '🍴': 'SILVERWARE',
  '💻': 'COMPUTER',
  '✈️': 'PLANE',
} as const

const unicodeToNewEmojiNameMap: { [key: string]: EmojiNameNew } = {
  '💰': 'EXTRA_CASH',
  '🏝': 'VACATION',
  '🎁': 'GIFT',
  '🎓': 'EDUCATION',
  '🏡': 'LIVING',
  '☔️': 'RAINY_DAY',
  '🎂': 'BIRTHDAY',
  '🤒': 'ILLNESS',
  '🎮': 'GAMES',
  '🍴': 'DINNER',
  '💻': 'TECHNOLOGY',
  '✈️': 'TRAVEL',
} as const

function unicodeToOldEmojiSvg(unicode: string): string {
  const emojiName = unicodeToOldEmojiNameMap[unicode]

  if (!emojiName) {
    throw Error(`No emoji name found for unicode "${unicode ?? 'undefined'}"`)
  }

  return EmojisOld[emojiName]
}

function unicodeToNewEmojiSvg({
  unicode,
  size,
  darkMode,
}: {
  unicode: string
  size: 24 | 48
  darkMode: boolean
}): string {
  const emojiName = unicodeToNewEmojiNameMap[unicode]

  if (!emojiName) {
    throw Error(`No new emoji name found for unicode "${unicode ?? 'undefined'}"`)
  }

  const emojiSizes = EmojisNew[emojiName][darkMode ? 'dark' : 'light']

  return size === 24 ? emojiSizes.svg24 : emojiSizes.svg48
}

export function unicodeToEmojiSvg({
  unicode,
  size,
  darkMode,
  version,
}: {
  unicode: string
  size: 24 | 48
  darkMode: boolean
  version: 'old' | 'new'
}): string {
  if (version === 'new') {
    return unicodeToNewEmojiSvg({ unicode, size, darkMode })
  } else {
    return unicodeToOldEmojiSvg(unicode)
  }
}
